/*  stream-sac v3.0.1 2022-09-26T12:38:40.499Z licensed CC0-1.0 */
/**
 * Check if the given character code, or the character code at the first
 * character, is a whitespace character.
 *
 * @param {string|number} character
 * @returns {boolean} Whether `character` is a whitespace character
 */
function isWhitespaceCharacter(character) {
  return /\s/.test(
    typeof character === 'number'
      ? String.fromCharCode(character)
      : character.charAt(0)
  )
}

/**
 * Copyright (C) 2017-present by Andrea Giammarchi - @WebReflection
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */

const {replace} = '';
const ca = /[&<>'"]/g;

const esca = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  "'": '&#39;',
  '"': '&quot;'
};
const pe = m => esca[m];

/**
 * Safely escape HTML entities such as `&`, `<`, `>`, `"`, and `'`.
 * @param {string} es the input to safely escape
 * @returns {string} the escaped input, and it **throws** an error if
 *  the input type is unexpected, except for boolean and numbers,
 *  converted as string.
 */
const escape = es => replace.call(es, ca, pe);

function escapeStringRegexp$1(string) {
	if (typeof string !== 'string') {
		throw new TypeError('Expected a string');
	}

	// Escape characters with special meaning either inside or outside character sets.
	// Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
	return string
		.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
		.replace(/-/g, '\\x2d');
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0';

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 'ss'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

var lodash_deburr = deburr;

function escapeStringRegexp(string) {
	if (typeof string !== 'string') {
		throw new TypeError('Expected a string');
	}

	// Escape characters with special meaning either inside or outside character sets.
	// Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
	return string
		.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
		.replace(/-/g, '\\x2d');
}

const replacements = [
	// German umlauts
	['ß', 'ss'],
	['ä', 'ae'],
	['Ä', 'Ae'],
	['ö', 'oe'],
	['Ö', 'Oe'],
	['ü', 'ue'],
	['Ü', 'Ue'],

	// Latin
	['À', 'A'],
	['Á', 'A'],
	['Â', 'A'],
	['Ã', 'A'],
	['Ä', 'Ae'],
	['Å', 'A'],
	['Æ', 'AE'],
	['Ç', 'C'],
	['È', 'E'],
	['É', 'E'],
	['Ê', 'E'],
	['Ë', 'E'],
	['Ì', 'I'],
	['Í', 'I'],
	['Î', 'I'],
	['Ï', 'I'],
	['Ð', 'D'],
	['Ñ', 'N'],
	['Ò', 'O'],
	['Ó', 'O'],
	['Ô', 'O'],
	['Õ', 'O'],
	['Ö', 'Oe'],
	['Ő', 'O'],
	['Ø', 'O'],
	['Ù', 'U'],
	['Ú', 'U'],
	['Û', 'U'],
	['Ü', 'Ue'],
	['Ű', 'U'],
	['Ý', 'Y'],
	['Þ', 'TH'],
	['ß', 'ss'],
	['à', 'a'],
	['á', 'a'],
	['â', 'a'],
	['ã', 'a'],
	['ä', 'ae'],
	['å', 'a'],
	['æ', 'ae'],
	['ç', 'c'],
	['è', 'e'],
	['é', 'e'],
	['ê', 'e'],
	['ë', 'e'],
	['ì', 'i'],
	['í', 'i'],
	['î', 'i'],
	['ï', 'i'],
	['ð', 'd'],
	['ñ', 'n'],
	['ò', 'o'],
	['ó', 'o'],
	['ô', 'o'],
	['õ', 'o'],
	['ö', 'oe'],
	['ő', 'o'],
	['ø', 'o'],
	['ù', 'u'],
	['ú', 'u'],
	['û', 'u'],
	['ü', 'ue'],
	['ű', 'u'],
	['ý', 'y'],
	['þ', 'th'],
	['ÿ', 'y'],
	['ẞ', 'SS'],

	// Vietnamese
	['à', 'a'],
	['À', 'A'],
	['á', 'a'],
	['Á', 'A'],
	['â', 'a'],
	['Â', 'A'],
	['ã', 'a'],
	['Ã', 'A'],
	['è', 'e'],
	['È', 'E'],
	['é', 'e'],
	['É', 'E'],
	['ê', 'e'],
	['Ê', 'E'],
	['ì', 'i'],
	['Ì', 'I'],
	['í', 'i'],
	['Í', 'I'],
	['ò', 'o'],
	['Ò', 'O'],
	['ó', 'o'],
	['Ó', 'O'],
	['ô', 'o'],
	['Ô', 'O'],
	['õ', 'o'],
	['Õ', 'O'],
	['ù', 'u'],
	['Ù', 'U'],
	['ú', 'u'],
	['Ú', 'U'],
	['ý', 'y'],
	['Ý', 'Y'],
	['ă', 'a'],
	['Ă', 'A'],
	['Đ', 'D'],
	['đ', 'd'],
	['ĩ', 'i'],
	['Ĩ', 'I'],
	['ũ', 'u'],
	['Ũ', 'U'],
	['ơ', 'o'],
	['Ơ', 'O'],
	['ư', 'u'],
	['Ư', 'U'],
	['ạ', 'a'],
	['Ạ', 'A'],
	['ả', 'a'],
	['Ả', 'A'],
	['ấ', 'a'],
	['Ấ', 'A'],
	['ầ', 'a'],
	['Ầ', 'A'],
	['ẩ', 'a'],
	['Ẩ', 'A'],
	['ẫ', 'a'],
	['Ẫ', 'A'],
	['ậ', 'a'],
	['Ậ', 'A'],
	['ắ', 'a'],
	['Ắ', 'A'],
	['ằ', 'a'],
	['Ằ', 'A'],
	['ẳ', 'a'],
	['Ẳ', 'A'],
	['ẵ', 'a'],
	['Ẵ', 'A'],
	['ặ', 'a'],
	['Ặ', 'A'],
	['ẹ', 'e'],
	['Ẹ', 'E'],
	['ẻ', 'e'],
	['Ẻ', 'E'],
	['ẽ', 'e'],
	['Ẽ', 'E'],
	['ế', 'e'],
	['Ế', 'E'],
	['ề', 'e'],
	['Ề', 'E'],
	['ể', 'e'],
	['Ể', 'E'],
	['ễ', 'e'],
	['Ễ', 'E'],
	['ệ', 'e'],
	['Ệ', 'E'],
	['ỉ', 'i'],
	['Ỉ', 'I'],
	['ị', 'i'],
	['Ị', 'I'],
	['ọ', 'o'],
	['Ọ', 'O'],
	['ỏ', 'o'],
	['Ỏ', 'O'],
	['ố', 'o'],
	['Ố', 'O'],
	['ồ', 'o'],
	['Ồ', 'O'],
	['ổ', 'o'],
	['Ổ', 'O'],
	['ỗ', 'o'],
	['Ỗ', 'O'],
	['ộ', 'o'],
	['Ộ', 'O'],
	['ớ', 'o'],
	['Ớ', 'O'],
	['ờ', 'o'],
	['Ờ', 'O'],
	['ở', 'o'],
	['Ở', 'O'],
	['ỡ', 'o'],
	['Ỡ', 'O'],
	['ợ', 'o'],
	['Ợ', 'O'],
	['ụ', 'u'],
	['Ụ', 'U'],
	['ủ', 'u'],
	['Ủ', 'U'],
	['ứ', 'u'],
	['Ứ', 'U'],
	['ừ', 'u'],
	['Ừ', 'U'],
	['ử', 'u'],
	['Ử', 'U'],
	['ữ', 'u'],
	['Ữ', 'U'],
	['ự', 'u'],
	['Ự', 'U'],
	['ỳ', 'y'],
	['Ỳ', 'Y'],
	['ỵ', 'y'],
	['Ỵ', 'Y'],
	['ỷ', 'y'],
	['Ỷ', 'Y'],
	['ỹ', 'y'],
	['Ỹ', 'Y'],

	// Arabic
	['ء', 'e'],
	['آ', 'a'],
	['أ', 'a'],
	['ؤ', 'w'],
	['إ', 'i'],
	['ئ', 'y'],
	['ا', 'a'],
	['ب', 'b'],
	['ة', 't'],
	['ت', 't'],
	['ث', 'th'],
	['ج', 'j'],
	['ح', 'h'],
	['خ', 'kh'],
	['د', 'd'],
	['ذ', 'dh'],
	['ر', 'r'],
	['ز', 'z'],
	['س', 's'],
	['ش', 'sh'],
	['ص', 's'],
	['ض', 'd'],
	['ط', 't'],
	['ظ', 'z'],
	['ع', 'e'],
	['غ', 'gh'],
	['ـ', '_'],
	['ف', 'f'],
	['ق', 'q'],
	['ك', 'k'],
	['ل', 'l'],
	['م', 'm'],
	['ن', 'n'],
	['ه', 'h'],
	['و', 'w'],
	['ى', 'a'],
	['ي', 'y'],
	['َ‎', 'a'],
	['ُ', 'u'],
	['ِ‎', 'i'],
	['٠', '0'],
	['١', '1'],
	['٢', '2'],
	['٣', '3'],
	['٤', '4'],
	['٥', '5'],
	['٦', '6'],
	['٧', '7'],
	['٨', '8'],
	['٩', '9'],

	// Persian / Farsi
	['چ', 'ch'],
	['ک', 'k'],
	['گ', 'g'],
	['پ', 'p'],
	['ژ', 'zh'],
	['ی', 'y'],
	['۰', '0'],
	['۱', '1'],
	['۲', '2'],
	['۳', '3'],
	['۴', '4'],
	['۵', '5'],
	['۶', '6'],
	['۷', '7'],
	['۸', '8'],
	['۹', '9'],

	// Pashto
	['ټ', 'p'],
	['ځ', 'z'],
	['څ', 'c'],
	['ډ', 'd'],
	['ﺫ', 'd'],
	['ﺭ', 'r'],
	['ړ', 'r'],
	['ﺯ', 'z'],
	['ږ', 'g'],
	['ښ', 'x'],
	['ګ', 'g'],
	['ڼ', 'n'],
	['ۀ', 'e'],
	['ې', 'e'],
	['ۍ', 'ai'],

	// Urdu
	['ٹ', 't'],
	['ڈ', 'd'],
	['ڑ', 'r'],
	['ں', 'n'],
	['ہ', 'h'],
	['ھ', 'h'],
	['ے', 'e'],

	// Russian
	['А', 'A'],
	['а', 'a'],
	['Б', 'B'],
	['б', 'b'],
	['В', 'V'],
	['в', 'v'],
	['Г', 'G'],
	['г', 'g'],
	['Д', 'D'],
	['д', 'd'],
	['ъе', 'ye'],
	['Ъе', 'Ye'],
	['ъЕ', 'yE'],
	['ЪЕ', 'YE'],
	['Е', 'E'],
	['е', 'e'],
	['Ё', 'Yo'],
	['ё', 'yo'],
	['Ж', 'Zh'],
	['ж', 'zh'],
	['З', 'Z'],
	['з', 'z'],
	['И', 'I'],
	['и', 'i'],
	['ый', 'iy'],
	['Ый', 'Iy'],
	['ЫЙ', 'IY'],
	['ыЙ', 'iY'],
	['Й', 'Y'],
	['й', 'y'],
	['К', 'K'],
	['к', 'k'],
	['Л', 'L'],
	['л', 'l'],
	['М', 'M'],
	['м', 'm'],
	['Н', 'N'],
	['н', 'n'],
	['О', 'O'],
	['о', 'o'],
	['П', 'P'],
	['п', 'p'],
	['Р', 'R'],
	['р', 'r'],
	['С', 'S'],
	['с', 's'],
	['Т', 'T'],
	['т', 't'],
	['У', 'U'],
	['у', 'u'],
	['Ф', 'F'],
	['ф', 'f'],
	['Х', 'Kh'],
	['х', 'kh'],
	['Ц', 'Ts'],
	['ц', 'ts'],
	['Ч', 'Ch'],
	['ч', 'ch'],
	['Ш', 'Sh'],
	['ш', 'sh'],
	['Щ', 'Sch'],
	['щ', 'sch'],
	['Ъ', ''],
	['ъ', ''],
	['Ы', 'Y'],
	['ы', 'y'],
	['Ь', ''],
	['ь', ''],
	['Э', 'E'],
	['э', 'e'],
	['Ю', 'Yu'],
	['ю', 'yu'],
	['Я', 'Ya'],
	['я', 'ya'],

	// Romanian
	['ă', 'a'],
	['Ă', 'A'],
	['ș', 's'],
	['Ș', 'S'],
	['ț', 't'],
	['Ț', 'T'],
	['ţ', 't'],
	['Ţ', 'T'],

	// Turkish
	['ş', 's'],
	['Ş', 'S'],
	['ç', 'c'],
	['Ç', 'C'],
	['ğ', 'g'],
	['Ğ', 'G'],
	['ı', 'i'],
	['İ', 'I'],

	// Armenian
	['ա', 'a'],
	['Ա', 'A'],
	['բ', 'b'],
	['Բ', 'B'],
	['գ', 'g'],
	['Գ', 'G'],
	['դ', 'd'],
	['Դ', 'D'],
	['ե', 'ye'],
	['Ե', 'Ye'],
	['զ', 'z'],
	['Զ', 'Z'],
	['է', 'e'],
	['Է', 'E'],
	['ը', 'y'],
	['Ը', 'Y'],
	['թ', 't'],
	['Թ', 'T'],
	['ժ', 'zh'],
	['Ժ', 'Zh'],
	['ի', 'i'],
	['Ի', 'I'],
	['լ', 'l'],
	['Լ', 'L'],
	['խ', 'kh'],
	['Խ', 'Kh'],
	['ծ', 'ts'],
	['Ծ', 'Ts'],
	['կ', 'k'],
	['Կ', 'K'],
	['հ', 'h'],
	['Հ', 'H'],
	['ձ', 'dz'],
	['Ձ', 'Dz'],
	['ղ', 'gh'],
	['Ղ', 'Gh'],
	['ճ', 'tch'],
	['Ճ', 'Tch'],
	['մ', 'm'],
	['Մ', 'M'],
	['յ', 'y'],
	['Յ', 'Y'],
	['ն', 'n'],
	['Ն', 'N'],
	['շ', 'sh'],
	['Շ', 'Sh'],
	['ո', 'vo'],
	['Ո', 'Vo'],
	['չ', 'ch'],
	['Չ', 'Ch'],
	['պ', 'p'],
	['Պ', 'P'],
	['ջ', 'j'],
	['Ջ', 'J'],
	['ռ', 'r'],
	['Ռ', 'R'],
	['ս', 's'],
	['Ս', 'S'],
	['վ', 'v'],
	['Վ', 'V'],
	['տ', 't'],
	['Տ', 'T'],
	['ր', 'r'],
	['Ր', 'R'],
	['ց', 'c'],
	['Ց', 'C'],
	['ու', 'u'],
	['ՈՒ', 'U'],
	['Ու', 'U'],
	['փ', 'p'],
	['Փ', 'P'],
	['ք', 'q'],
	['Ք', 'Q'],
	['օ', 'o'],
	['Օ', 'O'],
	['ֆ', 'f'],
	['Ֆ', 'F'],
	['և', 'yev'],

	// Georgian
	['ა', 'a'],
	['ბ', 'b'],
	['გ', 'g'],
	['დ', 'd'],
	['ე', 'e'],
	['ვ', 'v'],
	['ზ', 'z'],
	['თ', 't'],
	['ი', 'i'],
	['კ', 'k'],
	['ლ', 'l'],
	['მ', 'm'],
	['ნ', 'n'],
	['ო', 'o'],
	['პ', 'p'],
	['ჟ', 'zh'],
	['რ', 'r'],
	['ს', 's'],
	['ტ', 't'],
	['უ', 'u'],
	['ფ', 'ph'],
	['ქ', 'q'],
	['ღ', 'gh'],
	['ყ', 'k'],
	['შ', 'sh'],
	['ჩ', 'ch'],
	['ც', 'ts'],
	['ძ', 'dz'],
	['წ', 'ts'],
	['ჭ', 'tch'],
	['ხ', 'kh'],
	['ჯ', 'j'],
	['ჰ', 'h'],

	// Czech
	['č', 'c'],
	['ď', 'd'],
	['ě', 'e'],
	['ň', 'n'],
	['ř', 'r'],
	['š', 's'],
	['ť', 't'],
	['ů', 'u'],
	['ž', 'z'],
	['Č', 'C'],
	['Ď', 'D'],
	['Ě', 'E'],
	['Ň', 'N'],
	['Ř', 'R'],
	['Š', 'S'],
	['Ť', 'T'],
	['Ů', 'U'],
	['Ž', 'Z'],

	// Dhivehi
	['ހ', 'h'],
	['ށ', 'sh'],
	['ނ', 'n'],
	['ރ', 'r'],
	['ބ', 'b'],
	['ޅ', 'lh'],
	['ކ', 'k'],
	['އ', 'a'],
	['ވ', 'v'],
	['މ', 'm'],
	['ފ', 'f'],
	['ދ', 'dh'],
	['ތ', 'th'],
	['ލ', 'l'],
	['ގ', 'g'],
	['ޏ', 'gn'],
	['ސ', 's'],
	['ޑ', 'd'],
	['ޒ', 'z'],
	['ޓ', 't'],
	['ޔ', 'y'],
	['ޕ', 'p'],
	['ޖ', 'j'],
	['ޗ', 'ch'],
	['ޘ', 'tt'],
	['ޙ', 'hh'],
	['ޚ', 'kh'],
	['ޛ', 'th'],
	['ޜ', 'z'],
	['ޝ', 'sh'],
	['ޞ', 's'],
	['ޟ', 'd'],
	['ޠ', 't'],
	['ޡ', 'z'],
	['ޢ', 'a'],
	['ޣ', 'gh'],
	['ޤ', 'q'],
	['ޥ', 'w'],
	['ަ', 'a'],
	['ާ', 'aa'],
	['ި', 'i'],
	['ީ', 'ee'],
	['ު', 'u'],
	['ޫ', 'oo'],
	['ެ', 'e'],
	['ޭ', 'ey'],
	['ޮ', 'o'],
	['ޯ', 'oa'],
	['ް', ''],

	// Greek
	['α', 'a'],
	['β', 'v'],
	['γ', 'g'],
	['δ', 'd'],
	['ε', 'e'],
	['ζ', 'z'],
	['η', 'i'],
	['θ', 'th'],
	['ι', 'i'],
	['κ', 'k'],
	['λ', 'l'],
	['μ', 'm'],
	['ν', 'n'],
	['ξ', 'ks'],
	['ο', 'o'],
	['π', 'p'],
	['ρ', 'r'],
	['σ', 's'],
	['τ', 't'],
	['υ', 'y'],
	['φ', 'f'],
	['χ', 'x'],
	['ψ', 'ps'],
	['ω', 'o'],
	['ά', 'a'],
	['έ', 'e'],
	['ί', 'i'],
	['ό', 'o'],
	['ύ', 'y'],
	['ή', 'i'],
	['ώ', 'o'],
	['ς', 's'],
	['ϊ', 'i'],
	['ΰ', 'y'],
	['ϋ', 'y'],
	['ΐ', 'i'],
	['Α', 'A'],
	['Β', 'B'],
	['Γ', 'G'],
	['Δ', 'D'],
	['Ε', 'E'],
	['Ζ', 'Z'],
	['Η', 'I'],
	['Θ', 'TH'],
	['Ι', 'I'],
	['Κ', 'K'],
	['Λ', 'L'],
	['Μ', 'M'],
	['Ν', 'N'],
	['Ξ', 'KS'],
	['Ο', 'O'],
	['Π', 'P'],
	['Ρ', 'R'],
	['Σ', 'S'],
	['Τ', 'T'],
	['Υ', 'Y'],
	['Φ', 'F'],
	['Χ', 'X'],
	['Ψ', 'PS'],
	['Ω', 'O'],
	['Ά', 'A'],
	['Έ', 'E'],
	['Ί', 'I'],
	['Ό', 'O'],
	['Ύ', 'Y'],
	['Ή', 'I'],
	['Ώ', 'O'],
	['Ϊ', 'I'],
	['Ϋ', 'Y'],

	// Disabled as it conflicts with German and Latin.
	// Hungarian
	// ['ä', 'a'],
	// ['Ä', 'A'],
	// ['ö', 'o'],
	// ['Ö', 'O'],
	// ['ü', 'u'],
	// ['Ü', 'U'],
	// ['ű', 'u'],
	// ['Ű', 'U'],

	// Latvian
	['ā', 'a'],
	['ē', 'e'],
	['ģ', 'g'],
	['ī', 'i'],
	['ķ', 'k'],
	['ļ', 'l'],
	['ņ', 'n'],
	['ū', 'u'],
	['Ā', 'A'],
	['Ē', 'E'],
	['Ģ', 'G'],
	['Ī', 'I'],
	['Ķ', 'K'],
	['Ļ', 'L'],
	['Ņ', 'N'],
	['Ū', 'U'],
	['č', 'c'],
	['š', 's'],
	['ž', 'z'],
	['Č', 'C'],
	['Š', 'S'],
	['Ž', 'Z'],

	// Lithuanian
	['ą', 'a'],
	['č', 'c'],
	['ę', 'e'],
	['ė', 'e'],
	['į', 'i'],
	['š', 's'],
	['ų', 'u'],
	['ū', 'u'],
	['ž', 'z'],
	['Ą', 'A'],
	['Č', 'C'],
	['Ę', 'E'],
	['Ė', 'E'],
	['Į', 'I'],
	['Š', 'S'],
	['Ų', 'U'],
	['Ū', 'U'],

	// Macedonian
	['Ќ', 'Kj'],
	['ќ', 'kj'],
	['Љ', 'Lj'],
	['љ', 'lj'],
	['Њ', 'Nj'],
	['њ', 'nj'],
	['Тс', 'Ts'],
	['тс', 'ts'],

	// Polish
	['ą', 'a'],
	['ć', 'c'],
	['ę', 'e'],
	['ł', 'l'],
	['ń', 'n'],
	['ś', 's'],
	['ź', 'z'],
	['ż', 'z'],
	['Ą', 'A'],
	['Ć', 'C'],
	['Ę', 'E'],
	['Ł', 'L'],
	['Ń', 'N'],
	['Ś', 'S'],
	['Ź', 'Z'],
	['Ż', 'Z'],

	// Disabled as it conflicts with Vietnamese.
	// Serbian
	// ['љ', 'lj'],
	// ['њ', 'nj'],
	// ['Љ', 'Lj'],
	// ['Њ', 'Nj'],
	// ['đ', 'dj'],
	// ['Đ', 'Dj'],
	// ['ђ', 'dj'],
	// ['ј', 'j'],
	// ['ћ', 'c'],
	// ['џ', 'dz'],
	// ['Ђ', 'Dj'],
	// ['Ј', 'j'],
	// ['Ћ', 'C'],
	// ['Џ', 'Dz'],

	// Disabled as it conflicts with German and Latin.
	// Slovak
	// ['ä', 'a'],
	// ['Ä', 'A'],
	// ['ľ', 'l'],
	// ['ĺ', 'l'],
	// ['ŕ', 'r'],
	// ['Ľ', 'L'],
	// ['Ĺ', 'L'],
	// ['Ŕ', 'R'],

	// Disabled as it conflicts with German and Latin.
	// Swedish
	// ['å', 'o'],
	// ['Å', 'o'],
	// ['ä', 'a'],
	// ['Ä', 'A'],
	// ['ë', 'e'],
	// ['Ë', 'E'],
	// ['ö', 'o'],
	// ['Ö', 'O'],

	// Ukrainian
	['Є', 'Ye'],
	['І', 'I'],
	['Ї', 'Yi'],
	['Ґ', 'G'],
	['є', 'ye'],
	['і', 'i'],
	['ї', 'yi'],
	['ґ', 'g'],

	// Dutch
	['Ĳ', 'IJ'],
	['ĳ', 'ij']

	// Danish
	// ['Æ', 'Ae'],
	// ['Ø', 'Oe'],
	// ['Å', 'Aa'],
	// ['æ', 'ae'],
	// ['ø', 'oe'],
	// ['å', 'aa']
];

const doCustomReplacements = (string, replacements) => {
	for (const [key, value] of replacements) {
		// TODO: Use `String#replaceAll()` when targeting Node.js 16.
		string = string.replace(new RegExp(escapeStringRegexp(key), 'g'), value);
	}

	return string;
};

function transliterate(string, options) {
	if (typeof string !== 'string') {
		throw new TypeError(`Expected a string, got \`${typeof string}\``);
	}

	options = {
		customReplacements: [],
		...options
	};

	const customReplacements = new Map([
		...replacements,
		...options.customReplacements
	]);

	string = string.normalize();
	string = doCustomReplacements(string, customReplacements);
	string = lodash_deburr(string);

	return string;
}

const overridableReplacements = [
	['&', ' and '],
	['🦄', ' unicorn '],
	['♥', ' love ']
];

const decamelize = string => {
	return string
		// Separate capitalized words.
		.replace(/([A-Z]{2,})(\d+)/g, '$1 $2')
		.replace(/([a-z\d]+)([A-Z]{2,})/g, '$1 $2')

		.replace(/([a-z\d])([A-Z])/g, '$1 $2')
		.replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1 $2');
};

const removeMootSeparators = (string, separator) => {
	const escapedSeparator = escapeStringRegexp$1(separator);

	return string
		.replace(new RegExp(`${escapedSeparator}{2,}`, 'g'), separator)
		.replace(new RegExp(`^${escapedSeparator}|${escapedSeparator}$`, 'g'), '');
};

function slugify(string, options) {
	if (typeof string !== 'string') {
		throw new TypeError(`Expected a string, got \`${typeof string}\``);
	}

	options = {
		separator: '-',
		lowercase: true,
		decamelize: true,
		customReplacements: [],
		preserveLeadingUnderscore: false,
		preserveTrailingDash: false,
		...options
	};

	const shouldPrependUnderscore = options.preserveLeadingUnderscore && string.startsWith('_');
	const shouldAppendDash = options.preserveTrailingDash && string.endsWith('-');

	const customReplacements = new Map([
		...overridableReplacements,
		...options.customReplacements
	]);

	string = transliterate(string, {customReplacements});

	if (options.decamelize) {
		string = decamelize(string);
	}

	let patternSlug = /[^a-zA-Z\d]+/g;

	if (options.lowercase) {
		string = string.toLowerCase();
		patternSlug = /[^a-z\d]+/g;
	}

	string = string.replace(patternSlug, options.separator);
	string = string.replace(/\\/g, '');
	if (options.separator) {
		string = removeMootSeparators(string, options.separator);
	}

	if (shouldPrependUnderscore) {
		string = `_${string}`;
	}

	if (shouldAppendDash) {
		string = `${string}-`;
	}

	return string;
}

const isAsciiLetter = (c) => {
    const ch = c.charCodeAt(0);
    return (ch >= 65 && ch <= 90) || (ch >= 97 && ch <= 122);
};

const emptyElements = [
    `area`,
    `base`,
    `br`,
    `col`,
    `embed`,
    `hr`,
    `img`,
    `input`,
    `link`,
    `meta`,
    `param`,
    `source`,
    `track`,
    `wbr`,
];

// todo only markdown - inline note worthy ?
const mardkownNoteWorthyCharacters = [
    `~`,
    `\``,
    `[`,
    `]`,
    `(`,
    `)`,
    `-`,
    `*`,
    `_`,
    `!`,
    `#`,
    `=`,
    `:`,
    // `<`,
    // `>`,
];


let i = 0;
const STATE = {
    TEXT: i++,
    START_RAW: i++,
    RAW_DESCRIPTION: i++,
    RAW: i++,
    CLOSING_RAW: i++,
    START_TITLE: i++,
    TITLE_TEXT: i++,
    UNDERTITLE1: i++,
    UNDERTITLE2: i++,
    ORDERED_LIST_START: i++,
    LIST_ITEM_TEXT: i++,
    LIST_ITEM_START: i++,
    LIST_ITEM_END: i++,
    QUOTE: i++,
    HORIZONTAL_RULE: i++,
    POTENTIAL_HTML: i++,
    AFTER_EMPTY_HTML: i++,
    INISIDE_HTML: i++,
    TABLE: i++,
    TABLE_MAYBE_END: i++,
};


const identity = (x) => {
    return x;
};

const DEFAULT_OPTIONS = {
    languagePrefix: `language-`,
    highlight: undefined,
    linkHrefHook: identity,
    mediaHook: undefined,
};

// scan for links
// remove special characters found inside links
// parse markdown with special characters left
// plaintext replace detected link with actual links (done inside parsing to avoid messing up reference links)
const scanForLinks = (plainText, start, stop) => {
    const words = plainText.split(` `);
    return words.reduce((links, word) => {
        if (word.startsWith(`https://`) || word.match(/[a-z]+\.[a-z]+/)?.[0]?.index === 0) {
            const index = plainText.indexOf(word);
            const indexEnd = index + word.length;
            if (index >= start && indexEnd <= stop) {
                links.push({
                    i: index,
                    iEnd: indexEnd,
                    original: word,
                    replacement: `<a href="${word}">${word}</a>`,
                });
            }
        }
        return links;
    }, []);
};

const removeIndexesInsideLinks = (indexes, links) => {
    let indexesI = 0;
    let linksI = 0;
    let position = 0;
    let removed = 0;
    while (linksI < links.length && indexesI < indexes.length) {
        const link = links[linksI];
        while (position !== undefined && position < link.iEnd) {
            const index = indexes[indexesI];
            position = index?.i;
            if (position !== undefined && position >= link.i && position <= link.iEnd) {
                // inside a link remove
                indexes.splice(indexesI, 1);
                removed += 1;
            } else {
                indexesI += 1;
            }
        }
        linksI += 1;
    }
    return removed;
};
const replaceThings = (text, links) => {
    links.forEach(({ original, replacement }) => {
        text = text.replace(original, replacement);
    });
    return text;
};


const start = function (controller, options = {}) {
    Object.assign(controller, {
        _refresh() {
            controller.firstCharcater = true;
            controller.indexes = [];
            controller.state = STATE.TEXT;
            controller.lastCharacter = ``;
            controller.linkText = ``;
            controller.rawDescription = ``;
            controller._currentTagName = ``;
            controller.inlineRaw = true;
            controller.titleLevel = 0;
            controller.skipStart = 0;
            controller.skipEnd = 0;
            controller.closingBackTicks = 0;
            controller.newLined = false;
        },
        _refreshDeep() {
            controller._refresh();
            controller.indexes.length = 0;
            controller.items.length = 0;
        },

        _selfBuffer(x) {
            controller.currentString = `${controller.currentString}${x}`;
        },

        _closeInlineStuff(currentStringStart, currentStringEnd, start = 0, end = controller.indexes.length) {
            if (controller.skipStart) {
                currentStringStart += Math.max(0, controller.skipStart);
                controller.skipStart = 0;
            }
            if (!controller.indexes.length || start === end) {
                return escape(controller.currentString.substring(currentStringStart, currentStringEnd));
            }


            const links = scanForLinks(controller.currentString, currentStringStart, currentStringEnd);
            const removed = removeIndexesInsideLinks(controller.indexes, links);
            end -= removed;
            let htmlOutput = ``;
            let lastUsed = controller.indexes[start]?.i ?? currentStringEnd;
            if (lastUsed > currentStringStart) {
                // substring does weird things if end is smaller than start
                htmlOutput = `${replaceThings(escape(controller.currentString.substring(currentStringStart, Math.max(lastUsed, currentStringStart))), links)}`;
            }
            let j;
            const nextCharacter = () => {
                return controller.indexes[j + 1]?.c;
            };
            const nextIndex = () => {
                return controller.indexes[j + 1]?.i;
            };
            const findClosingPair = (after, targetC) => {
                let result;
                let firstFound = false;
                let firstIndex = 0;
                for (let k = after; k < end; k += 1) {
                    const { i, c } = controller.indexes[k];
                    if (c === targetC) {
                        if (!firstFound || firstIndex + 1 !== i) {
                            firstFound = true;
                            firstIndex = i;
                            result = k;
                        } else {
                            return result;
                        }
                    } else {
                        firstFound = false;
                    }
                }
            };
            const findLastClosingTriple = (after, targetC) => {
                let result;
                let confirmedResult;
                let firstFound = false;
                let firstIndex = 0;
                let secondFound = false;
                let secondIndex = false;
                let thirdIndex;
                for (let k = after; k < end; k += 1) {
                    const { i, c } = controller.indexes[k];
                    if (c === targetC) {
                        if (!firstFound || (!secondFound && firstIndex + 1 !== i)) {
                            firstFound = true;
                            firstIndex = i;
                            result = k;
                        } else if (!secondFound) {
                            secondFound = true;
                            secondIndex = i;
                        } else if (secondIndex + 1 === i) {
                            confirmedResult = result;
                            thirdIndex = i;
                        } else if (confirmedResult) {
                            if (i === thirdIndex + 1) {
                                // 4 or 5  back ticks in a row
                                confirmedResult += 1;
                                thirdIndex += 1;
                            } else {
                                break;
                            }
                        } else {
                            firstFound = false;
                            secondFound = false;
                        }
                    } else {
                        firstFound = false;
                        secondFound = false;
                    }
                }
                return confirmedResult;
            };

            const findClosingSimple = (after, targetC) => {
                for (let k = after + 1; k < end; k += 1) {
                    const { i, c } = controller.indexes[k];
                    if (c === targetC) {
                        return k;
                    }
                }
            };
            
            // finds closing but takes into account if inside there are opening and closing pairs
        
            const findClosing = (after, opening, closing) => {
                let opens = 1;
                for (let k = after; k < end; k += 1) {
                    const { i, c } = controller.indexes[k];
                    if (c === closing) {
                        opens -= 1;
                        if (opens === 0) {
                            return k;
                        }
                    } else if (c === opening) {
                        opens += 1;
                    }
                }
            };

            for (j = start; j < end; j += 1) {
                const { i, c, u } = controller.indexes[j];
                if (u) {
                    continue;
                } else {
                    controller.indexes[j].u = true;
                }
                if (j - 1 > start && (controller.indexes[j].i - controller.indexes[j - 1].i > 1)) {
                    // handle standalone text in between worthy character groups
                    htmlOutput = `${htmlOutput}${escape(controller.currentString.substring(lastUsed, controller.indexes[j].i))}`;
                    lastUsed = controller.indexes[j].i;
                }
                if (c === `~`) {
                    if (nextCharacter() === `~` && nextIndex() === i + 1) {
                        // DELETED
                        // todo do not search inside raw stuff
                        const closingPairIndex = findClosingPair(j + 2, `~`);
                        if (closingPairIndex === undefined) {
                            // does not have a closing pair
                            j += 1;

                        } else {
                            controller.indexes[j + 1].u = true;
                            controller.indexes[closingPairIndex].u = true;
                            controller.indexes[closingPairIndex + 1].u = true;
                            htmlOutput = `${htmlOutput}<del>${replaceThings(
                                controller._closeInlineStuff(
                                    nextIndex() + 1,
                                    controller.indexes[closingPairIndex].i,
                                    j + 2,
                                    closingPairIndex,
                                ), links)}</del>`;
                            j = closingPairIndex + 1;
                            lastUsed = controller.indexes[closingPairIndex].i + 2;
                        }

                    }
                } else if (c === `[`) {
                    // link
                    const closingIndex = findClosing(j + 1, `[`, `]`);
                    if (closingIndex !== undefined) {
                        const closingPosition = controller.indexes[closingIndex].i;
                        const openingParenthese = findClosingSimple(closingIndex, `(`);
                        if (openingParenthese !== undefined && controller.indexes[openingParenthese].i === closingPosition + 1) {
                            const closingParenthese = findClosingSimple(openingParenthese, `)`);
                            if (closingParenthese !== undefined) {
                                // regular link
                                controller.indexes[closingIndex].u = true;
                                htmlOutput = `${htmlOutput}<a href="${controller.linkHrefHook(
                                    controller.currentString.substring(controller.indexes[openingParenthese].i + 1, controller.indexes[closingParenthese].i),
                                )}">${controller._closeInlineStuff(
                                    i + 1,
                                    controller.indexes[closingIndex].i,
                                    j + 1,
                                    closingIndex,
                                )}</a>`;
                                j = closingParenthese;
                                lastUsed = controller.indexes[closingParenthese].i + 1;
                            }
                        } else {
                            const openingBracket = findClosingSimple(closingIndex, `[`);
                            if (openingBracket !== undefined && controller.indexes[openingBracket].i === closingPosition + 1) {
                                const closingBracket = findClosingSimple(openingBracket, `]`);
                                if (closingBracket !== undefined) {
                                    // reference link
                                    controller.indexes[closingIndex].u = true;
                                    const slug = slugify(controller.currentString.substring(controller.indexes[openingBracket].i + 1, controller.indexes[closingBracket].i));
                                    htmlOutput = `${htmlOutput}<a href="#${slug}">${controller._closeInlineStuff(
                                        i + 1,
                                        controller.indexes[closingIndex].i,
                                        j + 1,
                                        closingIndex,
                                    )}</a>`;
                                    j = closingBracket;
                                    lastUsed = controller.indexes[closingBracket].i + 1;
                                }
                            } else {
                                // reference from a previous link
                                const colon = findClosingSimple(closingIndex, `:`);
                                if (colon !== undefined && controller.indexes[colon].i === closingPosition + 1) {
                                    const slug = slugify(controller.currentString.substring(i + 1, closingPosition + 1));
                                    htmlOutput = `<a id="${slug}" href="${controller.linkHrefHook(
                                        controller.currentString.substring(controller.indexes[colon].i + 2, currentStringEnd).trim(),
                                    )}">${controller.currentString.substring(i + 1, closingPosition)
                                        }</a>`;
                                    j = end;
                                    lastUsed = currentStringEnd;
                                    break;
                                } else {
                                    // reference link with only text
                                    controller.indexes[closingIndex].u = true;
                                    const slug = slugify(controller.currentString.substring(i + 1, closingPosition));
                                    htmlOutput = `${htmlOutput}<a href="#${slug}">${controller.currentString.substring(i + 1, closingPosition)
                                        }</a>`;
                                    j = closingIndex;
                                    lastUsed = closingPosition + 1;
                                }
                            }
                        }


                    }
                } else if (c === `!`) {
                    const openingBracketIndex = findClosingSimple(j, `[`);
                    if (openingBracketIndex) {
                        const closingIndex = findClosingSimple(openingBracketIndex, `]`);
                        if (closingIndex !== undefined) {
                            const closingPosition = controller.indexes[closingIndex].i;
                            const openingParenthese = findClosingSimple(closingIndex, `(`);
                            if (openingParenthese !== undefined && controller.indexes[openingParenthese].i === closingPosition + 1) {
                                const closingParenthese = findClosingSimple(openingParenthese, `)`);
                                if (closingParenthese !== undefined) {
                                    // regular image
                                    controller.indexes[closingIndex].u = true;
                                    const src = controller.currentString.substring(controller.indexes[openingParenthese].i + 1, controller.indexes[closingParenthese].i);
                                    const alt = controller._closeInlineStuff(
                                        controller.indexes[openingBracketIndex].i + 1,
                                        controller.indexes[closingIndex].i,
                                        j + 2,
                                        closingIndex,
                                    );
                                    let output;
                                    if (controller.mediaHook) {
                                        output = controller.mediaHook(src, alt);
                                    } else {
                                        output = `<img alt="${alt}" src="${src}">`;
                                    }
                                    htmlOutput = `${htmlOutput}${output}`;
                                    j = closingParenthese;
                                    lastUsed = controller.indexes[closingParenthese].i + 1;
                                }
                            }
                        }
                    }

                } else if (c === `*`) {
                    if (nextCharacter() === `*` && nextIndex() === i + 1) {
                        // strong
                        const closingPairIndex = findClosingPair(j + 2, `*`);
                        if (closingPairIndex) {
                            controller.indexes[j + 1].u = true;
                            controller.indexes[closingPairIndex].u = true;
                            controller.indexes[closingPairIndex + 1].u = true;
                            htmlOutput = `${htmlOutput}<strong>${replaceThings(controller._closeInlineStuff(
                                nextIndex() + 1,
                                controller.indexes[closingPairIndex].i,
                                j + 2,
                                closingPairIndex,
                            ), links)}</strong>`;
                            j = closingPairIndex + 1;
                            lastUsed = controller.indexes[closingPairIndex].i + 2;
                        } else {
                            j += 1;
                        }
                    } else {
                        // emphasis
                        const nextStar = findClosingSimple(j, `*`);
                        if (nextStar) {
                            controller.indexes[nextStar].u = true;
                            htmlOutput = `${htmlOutput}<em>${replaceThings(controller._closeInlineStuff(
                                i + 1,
                                controller.indexes[nextStar].i,
                                j + 1,
                                nextStar,
                            ), links)}</em>`;
                            j = nextStar;
                            lastUsed = controller.indexes[nextStar].i + 1;
                        }
                    }
                } else if (c === `_`) {
                    // todo deduplicate with above
                    if (nextCharacter() === `_` && nextIndex() === i + 1) {
                        // strong
                        const closingPairIndex = findClosingPair(j + 2, `_`);
                        if (closingPairIndex) {
                            controller.indexes[j + 1].u = true;
                            controller.indexes[closingPairIndex].u = true;
                            controller.indexes[closingPairIndex + 1].u = true;
                            htmlOutput = `${htmlOutput}<strong>${replaceThings(controller._closeInlineStuff(
                                nextIndex() + 1,
                                controller.indexes[closingPairIndex].i,
                                j + 2,
                                closingPairIndex,
                            ), links)}</strong>`;
                            j = closingPairIndex + 1;
                            lastUsed = controller.indexes[closingPairIndex].i + 2;
                        } else {
                            j += 1;
                        }
                    } else {
                        const nextStar = findClosingSimple(j, `_`);
                        if (nextStar) {
                            controller.indexes[nextStar].u = true;
                            htmlOutput = `${htmlOutput}<em>${replaceThings(controller._closeInlineStuff(
                                i + 1,
                                controller.indexes[nextStar].i,
                                j + 1,
                                nextStar,
                            ), links)}</em>`;
                            j = nextStar;
                            lastUsed = controller.indexes[nextStar].i + 1;
                        }
                    }
                } else if (c === `\``) {
                    let wastriplebacktick = false;
                    const restOfTripleOpening = findClosingPair(j + 1, `\``);
                    if (controller.indexes[restOfTripleOpening]?.i === i + 1) {
                        const startOfTripleClosing = findLastClosingTriple(j + 3, `\``);
                        if (startOfTripleClosing) {
                            controller.indexes[startOfTripleClosing].u = true;
                            controller.indexes[startOfTripleClosing + 2].u = true;
                            controller.indexes[startOfTripleClosing + 1].u = true;
                            htmlOutput = `${htmlOutput}<code>${escape(controller.currentString.substring(i + 3, controller.indexes[startOfTripleClosing].i))
                                }</code>`;
                            j = startOfTripleClosing + 2;
                            lastUsed = controller.indexes[startOfTripleClosing].i + 3;
                            wastriplebacktick = true;
                        }
                    }
                    if (!wastriplebacktick) {
                        const nextBackTick = findClosingSimple(j, `\``);
                        if (nextBackTick) {
                            //raw
                            controller.indexes[nextBackTick].u = true;
                            htmlOutput = `${htmlOutput}<code>${escape(controller.currentString.substring(i + 1, controller.indexes[nextBackTick].i))
                                }</code>`;
                            j = nextBackTick;
                            lastUsed = controller.indexes[nextBackTick].i + 1;
                        }
                    }
                } else ;
            }
            return `${htmlOutput}${replaceThings(escape(controller.currentString.substring(lastUsed, Math.max(currentStringEnd))), links)}`;

        },

        _closeCurrent(toPush, i = controller.currentString.length) {
            let skip;
            if (controller.skipEnd) {
                skip = controller.skipEnd;
                i -= skip;
            }
            let inlineOutput;
            if (controller.state === STATE.TEXT) {
                controller.skipStart -= 1;
            }
            if (controller.state !== STATE.HORIZONTAL_RULE &&
                controller.state !== STATE.CLOSING_RAW &&
                controller.state !== STATE.AFTER_EMPTY_HTML &&
                controller.state !== STATE.TABLE &&
                controller.state !== STATE.TABLE_MAYBE_END
            ) {
                inlineOutput = controller._closeInlineStuff(0, i).trim();
            }
            switch (controller.state) {
                case STATE.HORIZONTAL_RULE:
                    toPush.push(`<hr>`);
                    controller._refresh();
                    break;
                case STATE.TEXT:
                    if (inlineOutput) {
                        toPush.push(`<p>${inlineOutput}</p>`);
                    }
                    controller._refresh();
                    break;

                case STATE.AFTER_EMPTY_HTML:
                    toPush.push(controller.currentString.substring(0, i));
                    controller._refresh();
                    break;
                case STATE.QUOTE:
                    toPush.push(`<blockquote><p>${inlineOutput}</p></blockquote>`);
                    controller._refresh();
                    break;
                case STATE.LIST_ITEM_TEXT:
                    controller.items.push(inlineOutput);
                case STATE.LIST_ITEM_END:
                    const wasOrdered = controller.listTypeOrdered.pop();
                    let listContainerHtml;
                    if (wasOrdered) {
                        listContainerHtml = `ol`;
                    } else {
                        listContainerHtml = `ul`;
                    }
                    toPush.push(`<${listContainerHtml}>`);
                    controller.items.forEach(item => {
                        toPush.push(`<li>${item}</li>`);
                    });
                    toPush.push(`</${listContainerHtml}>`);
                    controller._refreshDeep();
                    break;
                case STATE.UNDERTITLE1:
                case STATE.UNDERTITLE2:
                case STATE.TITLE_TEXT:
                    toPush.push(`<h${controller.titleLevel}>${inlineOutput}</h${controller.titleLevel}>`);
                    controller._refresh();
                    break;
                case STATE.CLOSING_RAW:
                    let classText = ``;
                    if (controller.rawDescription) {
                        classText = ` class="${controller.languagePrefix}${escape(controller.rawDescription)}"`;
                    }

                    const rawString = controller.currentString.substring(controller.rawDescriptionEnd, i - 3).trim();
                    let currentInlineString;

                    let highlighted;
                    if (controller.highlight) {
                        highlighted = controller.highlight(rawString, controller.rawDescription);
                    }
                    if (highlighted) {
                        currentInlineString = `<pre><code${classText}>${highlighted}</code></pre>`;
                    } else {
                        currentInlineString = `<pre><code${classText}>${escape(rawString)}</code></pre>`;
                    }

                    toPush.push(currentInlineString);
                    controller._refresh();
                    break;
                case STATE.TABLE:
                    controller.items.push([controller.tableLineStart, i]);
                case STATE.TABLE_MAYBE_END:
                    // const s = controller.currentString.substring(0, i).trim();
                    // console.log(s);
                    toPush.push(`<table><thead>`);

                    let header = true;
                    let cellTag = `th`;
                    const alignments = [];
                    // first determine the alignments
                    controller.items.some(([start, end]) => {
                        const line = controller.currentString.substring(start, end);
                        if (!line.includes(`---`)) {
                            return;
                        }
                        line.split(`|`).map(tabledata => {
                            return tabledata.trim();
                        }).filter(Boolean).forEach(alignpattern => {
                            if (alignpattern.startsWith(":") && alignpattern.endsWith(":")) {
                                alignments.push(` style="text-align: center"`);
                            } else if (alignpattern.startsWith(":")) {
                                alignments.push(` style="text-align: left"`);
                            } else if (alignpattern.endsWith(":")) {
                                alignments.push(` style="text-align: right"`);
                            } else {
                                alignments.push(``);
                            }
                        });
                        return true;
                    });
                    controller.items.forEach(([start, end]) => {
                        let line = controller.currentString.substring(start, end);
                        if (header && line.includes(`---`)) {
                            header = false;
                            cellTag = `td`;
                            toPush.push(`</thead><tbody>`);
                            return;
                        }
                        line = line.replaceAll(`\\|`, `\0`); // escaped |, use Placeholder for the split then replace again below
                        toPush.push(`<tr>`);
                        const split = line.split(`|`).map(tabledata => {
                            return tabledata.trim();
                        }).filter(Boolean);
                        split.forEach((tabledata, position) => {
                            toPush.push(`<${cellTag}${alignments[position]}>${escape(tabledata.replaceAll(`\0`, `|`))}</${cellTag}>`);
                        });
                        // handle remaining (empty cells)
                        for (let i = split.length; i < alignments.length; i += 1) {
                            toPush.push(`<${cellTag}${alignments[i]}></${cellTag}>`);
                        }
                        
                        toPush.push(`</tr>`);
                    });
                    toPush.push(`</tbody></table>`);
                    controller._refreshDeep();
                    break;
                default:
                    return;

            }
        },

        _noteWorthyCharacters(c, i) {
            if (mardkownNoteWorthyCharacters.includes(c)) {
                controller.indexes.push({ c, i });
                return true;
            }
            return false;
        },
    });
    
    controller.indexes = [];
    controller.inside = [];
    controller.items = [];
    controller.listTypeOrdered = [];
    controller.currentString = ``;
    controller._refresh();
    Object.assign(controller, DEFAULT_OPTIONS, options);
};

const transform = function (bufferAsString, controller) {
    controller._selfBuffer(bufferAsString);
    const asString = controller.currentString;
    const { length } = asString;
    const toPush = []; // avoid pushing character by character
    let iAdjust = 0; // as we cut off the beginning of controller.currentString, i has to be adjusted
    let rawStartedAt = 0;
    let rawDescriptionStart = 0;

    for (let i = 0; i < length; i += 1) {
        const c = asString[i];
        if (controller.state === STATE.CLOSING_RAW) {
            if (c === `\``) {
                controller.closingBackTicks += 1;
                continue;
            } else {
                controller._closeCurrent(toPush, i - iAdjust);
                controller.currentString = asString.substr(i);
                iAdjust = i;
                controller._refresh();
            }
        }
        switch (controller.state) {
            case STATE.UNDERTITLE1:
            case STATE.UNDERTITLE2:
                controller.skipEnd += 1;
                if (c === `\n`) {
                    controller._closeCurrent(toPush, i - iAdjust + 1);
                    controller.currentString = asString.substr(i + 1);
                    iAdjust = i + 1;
                }
                break;
            case STATE.HORIZONTAL_RULE:
                if (c === `\n`) {
                    controller._closeCurrent(toPush, i - iAdjust);
                    controller.currentString = asString.substr(i + 1);
                    iAdjust = i + 1;
                } else {
                    controller.skipEnd += 1;
                }
                break;
            case STATE.POTENTIAL_HTML:
                if ((isWhitespaceCharacter(c) || (!isAsciiLetter(c) && c !== `-`)) && controller.lastCharacter === `<`) {
                    // was not html
                    controller.state = STATE.TEXT;
                    controller.skipStart -= +5;
                    controller.firstCharcater = false;
                } else if (c === `>`) {
                    let currentTagName = ``;
                    for (let j = controller.tagNameStart; j < asString.length; j += 1) {
                        if (!isAsciiLetter(asString[j]) && asString[j] !== `-`) {
                            break; // todo skip whitespace < img>
                        }
                        currentTagName = `${currentTagName}${asString[j]}`;
                    }

                    if (emptyElements.includes(currentTagName)) {
                        controller.state = STATE.AFTER_EMPTY_HTML;
                        controller.currentString = asString.substr(controller.tagNameStart - 1);
                        controller._closeCurrent(toPush, i + 1 - (controller.tagNameStart - 1));
                        controller.currentString = asString.substr(i + 1);
                        iAdjust = i + 1;
                    } else {
                        controller._currentTagName = currentTagName;
                        controller.state = STATE.INISIDE_HTML;
                    }

                } else ;

                controller.lastCharacter = c;
                break;
            case STATE.INISIDE_HTML:
                if (c === `>`) {
                    const closingTagName = asString.slice(i - controller._currentTagName.length, i);
                    if (controller._currentTagName === closingTagName) {


                        controller.state = STATE.AFTER_EMPTY_HTML;
                        controller.currentString = asString.substr(controller.tagNameStart - 1);
                        controller._closeCurrent(toPush, i + 1 - iAdjust);
                        controller.currentString = asString.substr(i + 1);
                        iAdjust = i + 1;
                    }
                }
                break;
            case STATE.TEXT:
                if (c === `\n`) {
                    if (controller.newLined) {
                        controller._closeCurrent(toPush, i - iAdjust);
                        controller.currentString = asString.substr(i + 1);
                        iAdjust = i + 1;
                    } else {
                        if (controller.firstCharcater) {
                            controller.skipStart += 1;
                        }
                        controller.newLined = true;
                    }
                } else if (c === `=` && controller.newLined &&
                    // avoid empty titles
                    !controller.firstCharcater) {
                    controller.state = STATE.UNDERTITLE1;
                    controller.skipStart -= 1;
                    controller.titleLevel = 1;
                    controller.skipEnd = 1;
                } else if (c === `-` && controller.newLined &&
                    // avoid empty titles
                    !controller.firstCharcater) {
                    controller.state = STATE.UNDERTITLE2;
                    controller.skipStart -= 1;
                    controller.titleLevel = 2;
                    controller.skipEnd = 1;
                } else {
                    if (controller.firstCharcater) {
                        if (c === `#`) {
                            controller.state = STATE.START_TITLE;
                            controller.titleLevel = 1;
                        } else if (c === `*` || c === `-`) {
                            controller.state = STATE.LIST_ITEM_START;
                            controller.lastCharacter = c;
                            controller.firstCharcater = false;
                        } else if (c === `0` || c === `1`) {
                            controller.state = STATE.ORDERED_LIST_START;
                            controller.lastCharacter = c;
                            controller.firstCharcater = false;
                        } else if (c === `>`) {
                            controller.state = STATE.QUOTE;
                            iAdjust += 1;
                            controller.skipStart += 1;
                        } else if (c === `\``) {
                            controller.state = STATE.START_RAW;
                            controller.backTicks = 1;
                            rawStartedAt = i;
                            controller.firstCharcater = false;
                        } else if (isWhitespaceCharacter(c)) {
                            controller.skipStart += 1;
                        } else if (c === `|`) {
                            controller.state = STATE.TABLE;
                            controller.tableLineStart = i - iAdjust;
                        }  else if (c === `<`) {
                            controller.state = STATE.POTENTIAL_HTML;
                            controller.lastCharacter = c;
                            controller.tagNameStart = i + 1;
                        } else {
                            // c = controller._escapeHtml(c); // todo when closing
                            if (controller.newLined) {
                                // controller._selfBuffer(` `);
                                controller.newLined = false;
                            }
                            controller.firstCharcater = false;

                            if (controller._noteWorthyCharacters(c, i - iAdjust)) {
                                break;
                            }
                        }
                    } else {
                        if (controller.newLined && !isWhitespaceCharacter(c)) {
                            controller.newLined = false;
                        }
                        if (controller._noteWorthyCharacters(c, i - iAdjust)) {
                            break;
                        }
                    }
                }
                break;
            case STATE.QUOTE:
                if (controller._noteWorthyCharacters(c, i - iAdjust + 1)) {
                    break;
                }
                if (c === `\n`) {
                    if (controller.newLined) {
                        controller._closeCurrent(toPush, i - iAdjust);
                        controller.currentString = asString.substr(i + 1);
                        iAdjust = i + 1;
                    } else {
                        controller.newLined = true;
                    }
                } else {
                    if (controller.newLined) {
                        controller.newLined = false;
                    }
                }
                break;
            case STATE.ORDERED_LIST_START:
                if (Number.isFinite(Number(controller.lastCharacter))) {
                    if (c === `.`) {
                        controller.lastCharacter = c;
                    } else {
                        // force go loop to go again with current character
                        i -= 1;
                        controller.state = STATE.TEXT;
                    }
                } else if (controller.lastCharacter === `.`) {
                    if (c === ` `) {
                        controller.listTypeOrdered.push(true);
                        controller.state = STATE.LIST_ITEM_TEXT;

                        controller.skipStart += 3;
                        iAdjust = i - controller.skipStart + 1;



                    } else {
                        // force go loop to go again with current character
                        i -= 2;
                        controller.state = STATE.TEXT;
                    }
                }
                break;
            case STATE.LIST_ITEM_START:
                if (c === ` `) {
                    controller.listTypeOrdered.push(false);
                    controller.state = STATE.LIST_ITEM_TEXT;

                    controller.skipStart += 2;
                    iAdjust = i - controller.skipStart + 1;

                } else {
                    if (c === `-`) {
                        controller._refresh();
                        controller.state = STATE.HORIZONTAL_RULE;
                        controller.skipEnd = 2;
                    } else {
                        // revert 
                        controller.indexes.push({ c: controller.lastCharacter, i: i - 1 - iAdjust });
                        // force go loop to go again with current character
                        i -= 1;
                        controller.state = STATE.TEXT;
                    }
                }
                break;
            case STATE.LIST_ITEM_TEXT:
                if (controller._noteWorthyCharacters(c, i - iAdjust)) {
                    break;
                }
                if (c === `\n`) {
                    // do not controller._closeCurrent(toPush, i);
                    // since it will also close the list (to handle lists at the end of markdown without line break
                    const {skipStart} = controller;
                    const inlineOutput = controller._closeInlineStuff(0, i - iAdjust + 1).trim();
                    controller.items.push(inlineOutput);
                    controller.currentString = asString.substr(i + 1);
                    iAdjust = i + 1 + skipStart;
                    controller._refresh();
                    controller.state = STATE.LIST_ITEM_END;
                }
                break;
            case STATE.TITLE_TEXT:
                if (controller._noteWorthyCharacters(c, i - iAdjust)) {
                    break;
                }
                if (c === `\n`) {
                    controller._closeCurrent(toPush, i - iAdjust);
                    controller.currentString = asString.substr(i + 1);
                    iAdjust = i + 1;
                }
                break;

            case STATE.LIST_ITEM_END:
                if (c === `\n`) {
                    controller._closeCurrent(toPush, i - iAdjust);
                    controller.currentString = asString.substr(i + 1);
                    iAdjust = i + 1;
                } else if (isWhitespaceCharacter(c)) {
                    controller.skipStart += 1;
                } else if (c === `-` || c === `*`) {
                    controller.state = STATE.LIST_ITEM_START;
                } else if (Number.isFinite(Number(c))) {
                    controller.state = STATE.ORDERED_LIST_START;
                    controller.lastCharacter = c;
                }
                break;
            case STATE.START_TITLE:
                if (c === `#`) {
                    controller.titleLevel += 1;
                } else if (isWhitespaceCharacter(c)) {
                    controller.state = STATE.TITLE_TEXT;
                    controller.skipStart += controller.titleLevel + 1;
                } else {
                    //malformed title
                    controller.state = STATE.TEXT;
                }
                break;
            case STATE.START_RAW:
                if (c === `\``) {
                    controller.backTicks += 1;
                    if (controller.backTicks === 3) {
                        controller.state = STATE.RAW_DESCRIPTION;
                        rawDescriptionStart = i + 1;
                    }
                } else {
                    for (let q = rawStartedAt; q < i; q += 1) {
                        controller.indexes.push({ c: `\``, i: q - iAdjust });
                    }
                    controller.state = STATE.TEXT;
                    controller.backTicks = 0;
                }
                break;
            case STATE.RAW_DESCRIPTION:
                if (c === `\n`) {
                    controller.rawDescription = asString.substring(rawDescriptionStart, i);
                    controller.rawDescriptionEnd = i + 1 - iAdjust;
                    controller.state = STATE.RAW;
                } else if (!isAsciiLetter(c) && c !== `\r`) {
                    // not in the description but in the raw text all along todo test this more
                    for (let q = rawStartedAt; q < rawStartedAt + 3; q += 1) {
                        controller.indexes.push({ c: `\``, i: q - iAdjust });
                    }
                    controller.state = STATE.TEXT;
                    controller.backTicks = 0;
                }
                break;
            case STATE.RAW:
                if (c === `\``) {
                    controller.closingBackTicks += 1;
                    if (controller.closingBackTicks === controller.backTicks) {
                        controller.state = STATE.CLOSING_RAW;
                    }
                } else {
                    if (controller.closingBackTicks) {
                        controller.closingBackTicks = 0;
                    }
                }
                break;
            case STATE.TABLE:
            
                if (c === `\n`) {
                    controller.state = STATE.TABLE_MAYBE_END;
                    
                    controller.items.push([controller.tableLineStart, i - iAdjust]);
                }
                break;

            case STATE.TABLE_MAYBE_END:
        
                if (c === `|`) {
                    controller.state = STATE.TABLE;
                    controller.tableLineStart = i - iAdjust;
                    break;
                } else if (isWhitespaceCharacter(c)) {
                    break;
                }
                controller._closeCurrent(toPush, i - iAdjust);
                controller.currentString = asString.substr(i);
                iAdjust = i;
                break;
            default:
                throw (`Invalid state ${controller.state}`);
        }
    }

    if (toPush.length) {
        controller.push(toPush.join(``));
    }

};

const flush = function (controller) {
    const toPush = [];
    controller._closeCurrent(toPush);
    toPush.forEach(string => {
        controller.push(string);
    });
    controller._refresh();
};

const createMarkdownParserStream = (options = {}) => {
    return new TransformStream({
        start(controller) {
            controller.push = controller.enqueue.bind(controller);
            start(controller, options);
        },

        transform,
        flush,
    });
};

export { createMarkdownParserStream };
